import { render } from "./UploadedTemplateReviewModal.vue?vue&type=template&id=06c34aec&ts=true"
import script from "./UploadedTemplateReviewModal.vue?vue&type=script&lang=ts"
export * from "./UploadedTemplateReviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__